import { useContext, useState } from 'react'
import { Container } from 'react-grid-system'
import { MdCheck } from 'react-icons/md'

import Input from '../../components/input/Input'
import { HeaderLarge } from '../../components/typography/Header'
import { LanguageContext } from '../../contexts/LanguageContext'
import { TranslatedWordsContext } from '../../contexts/TranslatedWordsContext'
import translation_codes from './translation_codes.json'

function Translation() {
  const { language, setLanguage } = useContext(LanguageContext)
  const { translatedWords } = useContext(TranslatedWordsContext)
  const [languageFilter, setLanguageFilter] = useState('')

  function handleLanguageChange(language) {
    setLanguage(language)
    localStorage.setItem('language', JSON.stringify(language))
    window.location.reload()
  }

  return (
    <Container style={{ maxWidth: '1000px' }}>
      <HeaderLarge>{translatedWords?.lang}</HeaderLarge>

      <div style={{ marginBottom: 'var(--sm)' }}>
        <Input
          value={languageFilter}
          setValue={setLanguageFilter}
          placeholder={`${translatedWords?.search}`}
          style={{ width: '50%' }}
        />
      </div>

      {translation_codes.text
        .filter((item) => {
          return item.language
            .toLowerCase()
            .includes(languageFilter?.toLowerCase())
        })
        .map((item) => {
          return (
            <button
              className={`translation-item ${
                language?.code === item?.code ? 'active' : ''
              }`}
              onClick={() => {
                handleLanguageChange(item)
              }}
            >
              <div>{item.language}</div>
              {language?.code === item?.code && (
                <div className="translation-item-check">
                  <MdCheck />
                </div>
              )}
            </button>
          )
        })}
    </Container>
  )
}

export default Translation
